export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-768w.5dc53c54.webp";